<template>
    <div :id="computed_id" class="bs-stepper">
        <div class="bs-stepper-header" role="tablist">
            <div v-for="(step, index) in steps" :key="step.id" 
                :class="(index+1) < steps.length ? 'step sl' : 'step'" 
                :data-target="'#'+step.id">
                <button type="button" 
                    class="step-trigger p-3"
                    role="tab"
                    :aria-controls="step.id"
                    :id="step.id+'-trigger'">
                    <span class="bs-stepper-circle">{{index + 1}}</span>
                    <span class="bs-stepper-label">{{step.title}}</span>
                </button>
            </div>
        </div>
        <div class="bs-stepper-content mt-2 pb-0">
            <slot 
                :next="next"
                :previous="previous"
                :currentIndex="currentIndex"
                :length="length">
            </slot>
        </div>
        <div class="text-right mr-3"
            v-if="!actions || actions == 'true' || actions == true">
            <button
                :disabled="currentIndex == 0" 
                type="button" :class="currentIndex == 0 ? 'btn btn-light' : 'btn btn-info'"
                @click="previous">
                Anterior
            </button>
            <button 
                :disabled="(currentIndex+1) >= length"
                type="button" :class="(currentIndex+1) < length ? 'btn btn-info' : 'btn btn-light'"
                @click="next">
                Siguiente
            </button>
        </div>
    </div>
</template>

<script>
import Stepper from 'bs-stepper';

export default {
    props: [
        'id',
        'actions',
    ],
    data() { return {
        steps: [],
        stepper: null,
        currentIndex: 0,
        length: 0,
    }},
    computed: {
        computed_id() {
            if(this.id == undefined) {
                return ('stepper-' + this._uid);
            } else {
                return this.id;
            }
        },
    },
    mounted() {
        const vm = this;

        vm.$on('SteeperEntry', async function(data) {
            vm.steps.push(data);
            vm.$nextTick(() => {
                $('.step.sl').after('<div class="line"></div>');
            });
        });

        $(document).ready(function () {
            vm.stepper = new Stepper($('.bs-stepper')[0])
            vm.length = vm.stepper._steps.length;
        })

        
    },
    methods: {
        next() {
            this.stepper.next();
            this.currentIndex ++;
        },
        previous() {
            this.stepper.previous();
            this.currentIndex --;
        }
    },
    watch: {

    }
}
</script>